import Api from '@/api/api.js'
import config_api from '@/api/config/_api_config'

// Several dashboard cards ask for the same short-lived, read-only capability at
// once. Share only an in-flight request for the same authenticated session;
// never retain the capability after resolution or across account changes.
const accessRequests = new Map()
const getTableauInfirmierAccess = () => {
    const client = config_api()
    const bearer = client.defaults.headers.Authorization || ''
    if (!bearer || bearer === 'Bearer ') {
        return client.post('/infirmier/tableau-access', {}, { timeout: 20000 }).then(response => response.data)
    }
    if (accessRequests.has(bearer)) return accessRequests.get(bearer)
    const request = client.post('/infirmier/tableau-access', {}, { timeout: 20000 })
        .then(response => response.data)
        .finally(() => { if (accessRequests.get(bearer) === request) accessRequests.delete(bearer) })
    accessRequests.set(bearer, request)
    return request
}

const read = (path, data) => {
    const { access_token, ...payload } = data
    return Api().post('/consultations/tableau-infirmier' + path, payload, {
        med_access_scoped: true, timeout: 20000, headers: { 'X-Infirmier-Access': access_token }
    }).then(response => response.data)
}
export default {
    getTableauInfirmierAccess,
    getTableauInfirmier(data) { return read('', data) },
    getRendezVousInfirmier(data) { return read('/rendez-vous', data) },   // RDV-003 : rendez-vous du jour, tous les médecins, lecture seule
    getFiltresTableauInfirmier(data) { return read('/filtres', data) },
    getStatistiquesTableauInfirmier(data) { return read('/statistiques', data) },
    async getSoinsAFaire({ categorie, page = 1, per_page = 30, patient_id }) {
        const access = await this.getTableauInfirmierAccess()
        const token = access && access.data && access.data.access_token
        if (!token) throw new Error('Accès infirmier indisponible.')
        return Api().get('/consultations/tableau-infirmier/soins-a-faire', {
            med_access_scoped: true, timeout: 20000,
            headers: { 'X-Infirmier-Access': token },
            params: { categorie, page, per_page, patient_id }
        }).then(response => response.data)
    },
    lireConstantes(data) { return read('/constantes/lire', data) },
    ouvrirConsultation(data) { return read('/ouvrir', data) },
    ouvrirSuiviSoins(data) { return read('/ouvrir-suivi-soins', data) },
    getConstantesAccess() { return config_api().post('/infirmier/constantes-access', {}, { timeout: 20000 }).then(response => response.data) },
    enregistrerConstantes(data, token) {
        return Api().post('/consultations/tableau-infirmier/constantes/enregistrer', data, {
            med_access_scoped: true, timeout: 20000, headers: { 'X-Infirmier-Constantes': token }
        }).then(response => response.data)
    }
}
